module.exports = __webpack_public_path__ + "img/Ape-Mint-Live-3.d41174f4.webp";